<ng-container *ngIf="order">
  <table class="mat-display-2">
    <tr *ngIf="shippingItem; else no_delivery_item">
      <td>{{ shippingItem.productName }}</td>
      <td>
        @if (shippingItem.unitsTotal > shippingItem.total) {
          <s>{{ shippingItem.unitsTotal | money: order.currency }}</s>
          {{ shippingItem.total | money: order.currency }}
        } @else {
          {{ shippingItem.total | money: order.currency }}
        }
      </td>
    </tr>

    <ng-template #no_delivery_item>
      <tr *ngIf="order.shippingTotal > 0">
        <td i18n="@@Money.ShippingTotal">Shipping Fee (incl)</td>
        <td>
          {{ order.shippingTotal | money: order.currency }}
        </td>
      </tr>
    </ng-template>

    <tr *ngIf="order.subtotal > 0">
      <td i18n="@@Money.Subtotal">Subtotal</td>
      <td>
        {{ order.subtotal | money: order.currency }}
      </td>
    </tr>

    <tr *ngFor="let adjustment of order.adjustments" class="order-adjustment">
      <ng-container *ngIf="order.adjustmentsTotal < 0 && !adjustment.orderItemId">
        <td>{{ adjustment.label }}</td>
        <td>{{ adjustment.amount | money: order.currency }}</td>
      </ng-container>
    </tr>

    <tr *ngIf="order.taxTotal > 0">
      <td i18n="@@Money.TaxIncluded">Tax (incl)</td>
      <td>
        {{ order.taxTotal | money: order.currency }}
      </td>
    </tr>

    <tr *ngIf="shipmentCostCalculation as calculation">
      <td colspan="2">
        <x-order-item-delivery-note [calculation]="calculation"></x-order-item-delivery-note>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <div class="border-top-color mt-3 pb-3"></div>
      </td>
    </tr>
    <tr class="mat-total total">
      <td class="text-uppercase" i18n="@@Money.Total">Total</td>
      <td>
        {{ order.total | money: order.currency }}
      </td>
    </tr>

    <ng-container *ngIf="order.paidTotal">
      <ng-container *ngIf="outstandingTotal">
        <tr class="total paid-total">
          <td class="text-uppercase" i18n="@@Money.TotalPaid">Total Paid</td>
          <td>
            {{ order.paidTotal | money: order.currency }}
          </td>
        </tr>
        <tr class="total total-outstanding">
          <td class="text-uppercase" i18n="@@Money.TotalOutstanding">Total Outstanding</td>
          <td>
            {{ outstandingTotal | money: order.currency }}
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </table>
</ng-container>
